import { mqMin } from '../breakpoints';
import type { Util } from '../../types/util';

const baseVariantShared: Util.CSSProperties = {
  marginLeft: 'auto',
  marginRight: 'auto',
};

const baseListVariantShared: Util.CSSProperties = {
  display: 'grid',
  listStyle: 'none',
  justifyContent: 'center',
  width: '100%',
  marginLeft: 0,
  gridTemplateColumns: 'repeat(1, 1fr)',
  rowGap: 's64',
  [mqMin.tabletSmall]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    rowGap: 's64',
    columnGap: '180px',
  },
};

const basePeopleSection: Util.VariantCSSKeys<PeopleSectionVariantsType> = {
  default: {
    '& ul': {
      ...baseListVariantShared,
    },
  },
  threeAcross: {
    ...baseVariantShared,
    maxWidth: '780px',
    [mqMin.tabletLandscape]: {
      maxWidth: 'none',
    },
    '& ul': {
      ...baseListVariantShared,
      [mqMin.tabletLandscape]: {
        gridTemplateColumns: 'repeat(3, minmax(150px, 1fr))',
        rowGap: 's64',
        columnGap: '180px',
      },
    },
  },
  fourAcross: {
    ...baseVariantShared,
    maxWidth: '380px',
    [mqMin.tabletLandscape]: {
      maxWidth: 'none',
    },
    '& ul': {
      ...baseListVariantShared,
      margin: '0 auto',
      maxWidth: '260px',
      [mqMin.tabletSmall]: {
        gridTemplateColumns: 'repeat(1, minmax(150px, 1fr))',
        rowGap: 's64',
        columnGap: '180px',
      },
      [mqMin.tabletLandscape]: {
        maxWidth: 'none',
        gridTemplateColumns: 'repeat(4, minmax(150px, 1fr))',
        rowGap: 's64',
        columnGap: 's64',
      },
    },
  },
};

const peopleSection: Util.VariantKeyModes<PeopleSectionVariantsType> = {
  products: {
    chart: basePeopleSection,
    chartblog: basePeopleSection,
    co: basePeopleSection,
    edu: basePeopleSection,
    scale: basePeopleSection,
    spark: basePeopleSection,
  },
};

export type PeopleSectionVariantsType = 'default' | 'threeAcross' | 'fourAcross';
export const peopleSectionVariants = Object.keys(basePeopleSection) as PeopleSectionVariantsType[];

export default peopleSection;
